import { useCallback, useId, useState } from "react";

import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Button } from "./ui/button";

export default function FancyTodoItem(props: {
  onToggle?: (checked: boolean) => void;
  label: string;
  buttonLabel?: string;
}) {
  const id = useId();
  const [toggled, setToggled] = useState(false);
  const handleCheck = useCallback(
    (checked: { valueOf: () => string | boolean }) => {
      const checkedValue = Boolean(checked.valueOf());
      props.onToggle?.(checkedValue);
      setToggled(checkedValue);
    },
    [toggled, props.onToggle],
  );
  return (
    <div className="flex items-center hover:bg-muted/70 rounded-lg w-full justify-between px-2 py-1">
      <div className="flex flex-row items-center gap-2 h-6">
        <Checkbox
          id={id}
          className="rounded-full [--primary:theme(colors.emerald.500)] [--primary-foreground:theme(colors.white)]"
          checked={toggled}
          onCheckedChange={handleCheck}
        />
        <Label
          htmlFor={id}
          className="peer-data-[state=checked]:line-throgh relative peer-data-[state=checked]:text-muted-foreground after:absolute after:top-1/2 after:left-0 after:h-px after:w-full after:origin-bottom after:-translate-y-1/2 after:scale-x-0 after:bg-muted-foreground after:transition-transform after:ease-in-out peer-data-[state=checked]:after:origin-bottom peer-data-[state=checked]:after:scale-x-100"
        >
          {props.label}
        </Label>
      </div>
      <Button
        disabled={toggled}
        onClick={() => handleCheck({ valueOf: () => true })}
        size="sm"
        variant="default"
        className="h-6 rounded-full text-xs"
      >
        {props.buttonLabel ?? "Allow"}
      </Button>
    </div>
  );
}
